import { render, staticRenderFns } from "./PhotoControl.vue?vue&type=template&id=7cf3a70b&"
import script from "./PhotoControl.vue?vue&type=script&lang=ts&"
export * from "./PhotoControl.vue?vue&type=script&lang=ts&"
import style0 from "./PhotoControl.vue?vue&type=style&index=0&id=7cf3a70b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports